var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.pendingApprovalUserList instanceof Array
      ? _c(
          "div",
          [
            _c("b-table", {
              attrs: {
                fields: _vm.tableFields,
                hover: "",
                "foot-clone": "",
                items: _vm.pendingApprovalUserList,
                bordered: "",
                striped: "",
                outlined: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "editted",
                  fn: function(row) {
                    return [
                      _c(
                        "ul",
                        _vm._l(row.item.editted, function(item, index) {
                          return _c("li", [
                            index !== "workingProfile"
                              ? _c("span", [
                                  _vm._v(_vm._s(index) + ":" + _vm._s(item))
                                ])
                              : _vm._e()
                          ])
                        })
                      )
                    ]
                  }
                },
                {
                  key: "action",
                  fn: function(row) {
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-success" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.confirmNewInfo(row.item, $event.target)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Approve\n                "
                          )
                        ]
                      ),
                      _vm._v(" |\n                "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "danger" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.confirmNewInfo(row.item, $event.target)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Reject\n                "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      : _c("p", [_c("b", [_vm._v("This is no user pending update info")])]),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d800ae42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d800ae42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/PendingApproveEditUserInfo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d800ae42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/PendingApproveEditUserInfo.vue
// module chunks = 0